// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"3d1f340d","706":"f6fea4eb"}[chunkId] + ".chunk.css";
};